var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.note && _vm.note._id)?_c('tiptap-editor',{key:_vm.note._id,attrs:{"note":_vm.note,"isGuest":true,"readOnly":true,"isOwner":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }